import React, { useRef, useState, useEffect } from "react";
import { useInput } from "react-admin";
import { TextField } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import config from '../config.json';
import { stringify } from 'query-string';
import { saveTokens } from '../utils/saveTokens';
import notify from './CustomUseNotify';

function uniqueBy(a, key, condition) {
    let seen = {};
    for (let i in a) {
        const item = a[i];
        if (seen[key(item)] == null || condition(item))
            seen[key(item)] = item;
    }
    return Object.keys(seen).map(key => seen[key]);
}
export default function ParkingInfoSelector(props) {
    const { resourcePath, resourceParam, source, filter, label = "", getOptionValue, getOptionLabel, multiple = false, uniqueOptions = (option => false), onSelect, limit = 10, customSort = ["id", "ASC"], setNoParkingInfo, setParkingNameSearched, setSelectedParkingInfo, clearParkingInfo } = props;
    const { input: { value, onChange } } = useInput(props);
    const { input: { value: parkingInfoId } } = useInput({ ...props, id: "parking_info_id", source: "parking_info_id" });
    //const notify = useNotify();

    const [selectedOption, setSelectedOption] = useState(multiple ? [] : null);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");

    const fetchParkingTimeout = useRef(null);

    const handleOnChange = (newValue) => {
        onChange(newValue);

        if (onSelect)
            onSelect(newValue);
    };

    const handleInputChange = (event, value) => {
        setSearchText(value);
        if (setParkingNameSearched) {
            setParkingNameSearched(value)
        }
        handleOnChange(value);
    };

    const fetchParkings = () => {
        const token = sessionStorage.getItem('token');
        if (token != null && token !== "") {
            const filters = {};
            if (typeof parkingInfoId === "string") {
                filters[resourceParam] = parkingInfoId
            }
            if (typeof parkingInfoId === "number") {
                filters.id = [parkingInfoId]
            }
            // if (searchText !== "" && searchText !== null) {
            //     delete filters.id
            //     filters[resourceParam] = value;
            // }
            console.log(source)
            console.log(value)
            setLoading(true);
            var params = {
                user_id: sessionStorage.getItem("user_id"),
                filter: JSON.stringify({ ...filters, ...filter }),
                sort: JSON.stringify(customSort),
                page: 1,
                perPage: limit
            }
            fetch(`${config.HOST_NAME}/crm/v3/${resourcePath}?${stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    setLoading(false);
                    if (responseJson.success) {
                        if (responseJson.success && responseJson.data && responseJson.data.length === 0) {
                            if (setNoParkingInfo) setNoParkingInfo(true)
                            return
                        }
                        if (setNoParkingInfo) setNoParkingInfo(false)
                        if (resourcePath === "cardsInventory") {
                            setOptions(responseJson.data);
                        } else {
                            let tempOptions = uniqueBy(responseJson.data, getOptionValue, uniqueOptions);
                            if (multiple)
                                tempOptions = [{ id: "All" }].concat(tempOptions);
                            setOptions(tempOptions);
                        }
                        if (responseJson.data.length === 1 && searchText === "")
                            onOptionSelect(null, responseJson.data[0]);
                    } else {
                        notify(responseJson.message, 'warning');
                    }
                })
                .catch((e) => {
                    setLoading(false);
                    notify('Error fetching data', 'warning');
                    console.log(e);
                });
        }
    };

    const onOptionSelect = (event, option) => {
        if (multiple) {
            if (option[option.length - 1] && option[option.length - 1].id === "All") {
                let tempOptions = options.slice(1);
                setSelectedOption(tempOptions);
                handleOnChange("All");
            } else {
                setSelectedOption(option);
                handleOnChange(option.map(getOptionValue));

            }
        } else {
            setSelectedOption(option);
            handleOnChange(option ? getOptionValue(option) : null);
            if (setSelectedParkingInfo) {
                setSelectedParkingInfo(option);
            }
        }
    };

    // useEffect(() => {
    //     if (value != null && value !== "") {
    //         setLoading(true);
    //         const filters = { id: [parkingInfoId], ...filter };
    //         if (isNaN(value)) {
    //             filters[resourceParam ? resourceParam : source] = value;
    //         }
    //         var params = {
    //             user_id: sessionStorage.getItem("user_id"),
    //             filter: JSON.stringify(filters)
    //         }
    //         fetch(`${config.HOST_NAME}/crm/v3/${resourcePath}?${stringify(params)}`, {
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 Authorization: `Bearer ${sessionStorage.getItem('token')}`,
    //             },
    //         })
    //             .then(response => response.json())
    //             .then((responseJson) => {
    //                 setLoading(false);
    //                 if (responseJson.success && responseJson.data && responseJson.data.length > 0) {
    //                     if (setNoParkingInfo) setNoParkingInfo(false)
    //                     onOptionSelect(null, responseJson.data[0]);
    //                 } else {
    //                     if (setNoParkingInfo) setNoParkingInfo(true)
    //                 }
    //             })
    //             .catch((e) => {
    //                 setLoading(false);
    //             });
    //     }
    // }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (fetchParkingTimeout.current)
            clearTimeout(fetchParkingTimeout.current);
        fetchParkingTimeout.current = setTimeout(fetchParkings, 500);
    }, [searchText, parkingInfoId, filter]);  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() =>{
        setSelectedOption(null)
        setSearchText("")
    }, [clearParkingInfo])

    return <Autocomplete
        freeSolo
        blurOnSelect
        getOptionLabel={multiple ? (option => option.id === "All" ? "All" : getOptionLabel(option)) : getOptionLabel}
        getOptionSelected={(option, value) => option && getOptionValue(option) === getOptionValue(value)}
        loading={loading}
        onInputChange={handleInputChange}
        options={options}
        renderInput={params => <TextField {...params} label={label} variant="outlined" size="small" />}
        onChange={onOptionSelect}
        value={selectedOption}
        style={{ width: 250, marginTop: 10, marginBottom: 25 }}
    />;
}